// @flow
import * as React from 'react';
import { Link } from 'react-router';
import { Row, Col, Button, Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import editcampaign from '../../images/edit-campaign.png';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import PaginatedList from '../../components/PaginatedList';
import SidebarFilterBox from '../../components/SidebarFilterBox';

type Props = {
  locationId: string | number,
  currentOrgId: string | number,
  isNew: boolean,
  locations: Array<Object>,
  getLocations: Function
};

type State = {
  showArchived: boolean,
  filterValue: string,
  currentItemName?: string
};

class LocationSidebar extends React.Component<Props, State> {
  fuzzyFilterFactory: any;
  screenReaderContent: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
    this.fuzzyFilterFactory = fuzzyFilterFactory();
  }

  componentDidMount() {
    const customerId = this.props.currentOrgId;
    this.props.getLocations(customerId);
  }

  updateFilterValue = (filterValue: ?string) => {
    this.setState({ filterValue: filterValue || '' });
  };

  moveFocusToHeading = (item: Object) => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  render() {
    const { locationId, currentOrgId, locations } = this.props;

    const LineItem = props => {
      const { item } = props;
      return (
        <Row
          key={item.id}
          className={`sidebar-list-item ${item.isArchived && 'archived'}`}
          onClick={e => this.moveFocusToHeading(item)}
        >
          <Link to={`/customer/${currentOrgId}/sub-accounts/${item.id}`}>
            <Col
              sm={10}
              className={`overflow-ellipsis map-link ${
                locationId === item.id.toString() ? 'active' : ''
              }`}
            >
              <p title={item.name} className="single-line">
                <strong>{item.name}</strong>
              </p>
            </Col>
          </Link>
          <Link to={`/customer/${currentOrgId}/sub-accounts/${item.id}`}>
            <Col sm={2} className="edit-btn text-center campaign-edit-link">
              <Image src={editcampaign} responsive alt="Edit User" />
              <span className="campaign-edit-link-text">Edit</span>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={6}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing sub-account {this.state.currentItemName}
            </h3>
            <h1>Sub-Accounts</h1>
          </Col>

          <Col sm={12} md={6}>
            <div className="sidebar-new-btn">
              <LinkContainer to={`/customer/${currentOrgId}/sub-accounts/new`}>
                <Button bsStyle="primary" className="new-btn">
                  Create New
                </Button>
              </LinkContainer>
            </div>
          </Col>

          <Col sm={12}>
            <SidebarFilterBox
              onChange={this.updateFilterValue}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <PaginatedList
              filterValue={this.state.filterValue}
              itemsPerPage={10}
              component={LineItem}
              pageButtonLimit={5}
              items={locations}
              showArchived={this.state.showArchived}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
              pluralName="sub-accounts"
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="archiveCheckbox"
                id="archiveCheckbox"
                className="archive-checkbox"
                checked={this.state.showArchived}
                onChange={() =>
                  this.setState({ showArchived: !this.state.showArchived })
                }
              />
              <label htmlFor="archiveCheckbox" className="checkbox-label">
                Show Archived
              </label>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default LocationSidebar;



// WEBPACK FOOTER //
// ./src/components/sidebars/LocationSidebar.js